import StatusHandler from 'app/shared-components/StatusHandler'
import FormWithControls from 'app/shared-components/FormWithControls'
import requests from 'app/requests/BillingCompany.requests'

import useGetBillingCompany from '../hooks/useGetBillingCompany'
import fields from './communication.fields'

const Communication = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetBillingCompany(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                name="CommunicationTab"
                value={data}
                onSuccess={invalidate}
                fields={fields}
                requestParams={requests.communication({
                    id,
                })}
                exists
            />
        </StatusHandler>
    )
}

export default Communication
